export const ListLangs: Record<string, string> = {
  EN: "English",
  PL: "Polish",
  ES: "Spanish",
  UA: "Ukrainian",
  FR: "French",
  UZ: "Uzbek",
  JA: "Japanese",
};
